module.exports = __webpack_public_path__ + "5f63d6a61e0d40be410dc2975562950f.jpg";